import React, { Component } from "react";
import PropTypes from "prop-types";
import AppLoading from "../components/Loading";
import { IconButton } from "../components_v2/Buttons";
import { View, ScrollView, StyleSheet } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import * as DeviceActions from "../actions/DeviceActions";
import { translate } from "../locales/translate";
import ArTheme from "../argon-ui/Theme";
import {
  faEdit,
  faList,
  faPlayCircle,
  faPlusCircle,
  faReply,
  faTrashAlt,
  FONT_FAMILIES,
} from "../../assets/consts/faCharCodes";
import { HStack } from "native-base";
import { ArButton } from "../argon-ui";
import { getIsRTL } from "../util";

/**@augments {Component<props,state>} */
class MediaPlayerList extends Component {
  static propTypes = {
    smartSpeakerDeviceId: PropTypes.number.isRequired,
    onAddPlayListPress: PropTypes.func,
    onEditPress: PropTypes.func,
    onDeletePress: PropTypes.func,
    onRemoveTrackPress: PropTypes.func,
    onPlay: PropTypes.func,
    isKioskMode: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPlayListId: this.props.playListId || 0,
    };
  }

  handleOnAddPlayListPress = () => {
    typeof this.props.onAddPlayListPress === "function" &&
      this.props.onAddPlayListPress();
  };

  handleOnPlay = (playListId, playListUId, trackId) => {
    typeof this.props.onPlay === "function" &&
      this.props.onPlay(
        this.props.smartSpeakerDeviceId,
        this.props.smartSpeakerDeviceUId,
        playListId,
        playListUId,
        trackId
      );
  };
  componentDidMount() {
    // if (!this.props.DeviceReducer.multiMediaLoaded) {
    //   this.props.getAllPlaylists(this.props.AppReducer.accessToken);
    // }
  }

  renderPlayListInfo(playList) {
    // console.log("playList in renderPlayListInfo", playList);
    return (
      <View style={styles.container}>
        <View
          style={{
            flexDirection: "row",
            //justifyContent: "space-between",
            alignItems: "center",
            height: 52,
            marginBottom: 10,
          }}
        >
          <HStack space="3">
            <IconButton
              style={{
                width: 30,
                height: 30,
                borderRadius: 10,
                backgroundColor: ArTheme.COLORS.ERROR,
                justifyContent: "center",
              }}
              onPress={() => {
                typeof this.props.onDeletePress === "function" &&
                  this.props.onDeletePress(
                    playList.id,
                    playList.uId,
                    playList.title
                  );
              }}
              icon={{
                code: faTrashAlt,
                style: {
                  fontFamily: FONT_FAMILIES.PRO_LIGHT,
                  fontSize: 14,
                  color: ArTheme.COLORS.WHITE,
                },
              }}
            />
            <IconButton
              style={{
                width: 30,
                height: 30,
                borderRadius: 15,
                backgroundColor: ArTheme.COLORS.WHITE,
                justifyContent: "center",
              }}
              onPress={() => {
                typeof this.props.onEditPress === "function" &&
                  this.props.onEditPress(playList.id, playList.uId);
              }}
              icon={{
                code: faEdit,
                style: {
                  fontFamily: FONT_FAMILIES.PRO_LIGHT,
                  fontSize: 16,
                  color: ArTheme.COLORS.MUTED,
                },
              }}
            />
          </HStack>
          <Text
            style={{
              fontSize: 14,
              fontWeight: "bold",
              flex: 1,
              marginHorizontal: 10,
            }}
          >
            {playList.title}
          </Text>
          <IconButton
            style={{
              width: 30,
              height: 30,
              // marginEnd: 10,
              borderRadius: 10,
              backgroundColor: ArTheme.COLORS.MUTED,
              justifyContent: "center",
            }}
            onPress={() => {
              this.setState({ currentPlayListId: 0 });
            }}
            icon={{
              code: faReply,
              style: {
                fontFamily: FONT_FAMILIES.PRO_LIGHT,
                fontSize: 16,
                color: ArTheme.COLORS.WHITE,
              },
            }}
          />
        </View>
        <ScrollView style={{ flex: 1 }}>
          {playList.tracks
            .sort((a, b) => a.order - b.order)
            .map((track, i) => {
              return (
                <View key={i} style={styles.playListItem}>
                  <View style={styles.playListTitle}>
                    <Text>{track.title}</Text>
                  </View>

                  <IconButton
                    style={{
                      width: 32,
                      height: 32,
                    }}
                    onPress={() => {
                      this.handleOnPlay(playList.id, playList.uId, track.id);
                    }}
                    icon={{
                      code: faPlayCircle,
                      style: {
                        fontFamily: FONT_FAMILIES.PRO_LIGHT,
                        fontSize: 32,
                        color: ArTheme.COLORS.MUTED,
                      },
                    }}
                  />
                </View>
              );
            })}
        </ScrollView>
      </View>
    );
  }

  renderPlayLists() {
    var privateSongsCount = 0;
    return (
      <ScrollView
        style={[
          styles.container,
          {
            width: this.props.isKioskMode ? 400 : "100%",
          },
        ]}
      >
        <HStack justifyContent="space-between" my="2" alignItems="center">
          <Text style={styles.heading}>
            {translate("multiMedia.playLists")}
          </Text>

          <ArButton
            color="primary"
            icon={faPlusCircle}
            onPress={this.handleOnAddPlayListPress}
          >
            {translate("multiMedia.newPlayList")}
          </ArButton>
        </HStack>
        {/* === Todo  default List ===  */}

        {/* <View style={styles.playListItem}>
          <View style={styles.playListTitle}>
            <Text>
              {translate("multiMedia.mySongs")} ({privateSongsCount})
            </Text>
          </View>
          <IconButton
            style={{
              width: 30,
              height: 30,
              marginEnd: 10,
              borderWidth: 2,
              borderRadius: 6,
              borderColor: ArTheme.COLORS.MUTED,
              justifyContent: "center",
            }}
            icon={{
              code: faList,
              style: {
                fontFamily: FONT_FAMILIES.PRO_LIGHT,
                fontSize: 16,
                color: ArTheme.COLORS.MUTED,
              },
            }}
          />
          <IconButton
            style={{
              width: 32,
              height: 32,
            }}
            icon={{
              code: faPlayCircle,
              style: {
                fontFamily: FONT_FAMILIES.PRO_LIGHT,
                fontSize: 32,
                color: ArTheme.COLORS.MUTED,
              },
            }}
          />
        </View> */}
        {this.props.DeviceReducer.playLists.map((playList, i) => {
          return (
            <View key={i} style={styles.playListItem}>
              <View style={styles.playListTitle}>
                <Text>
                  {playList.title} ({playList.tracks.length})
                </Text>
              </View>
              <HStack space="3" alignItems="center">
                <IconButton
                  style={{
                    width: 30,
                    height: 30,
                    borderWidth: 2,
                    borderRadius: 6,
                    borderColor: ArTheme.COLORS.MUTED,
                    justifyContent: "center",
                  }}
                  onPress={() => {
                    this.setState({ currentPlayListId: playList.id });
                  }}
                  icon={{
                    code: faList,
                    style: {
                      fontFamily: FONT_FAMILIES.PRO_LIGHT,
                      fontSize: 15,
                      color: ArTheme.COLORS.MUTED,
                    },
                  }}
                />
                <IconButton
                  style={{
                    width: 32,
                    height: 32,
                  }}
                  onPress={() =>
                    this.handleOnPlay(
                      playList.id,
                      playList.uId,
                      playList.tracks[0]?.id
                    )
                  }
                  icon={{
                    code: faPlayCircle,
                    style: {
                      fontFamily: FONT_FAMILIES.PRO_LIGHT,
                      fontSize: 30,
                      color: ArTheme.COLORS.MUTED,
                    },
                  }}
                />
              </HStack>
            </View>
          );
        })}
      </ScrollView>
    );
  }

  render() {
    if (!this.props.DeviceReducer.multiMediasLoaded) return <AppLoading />;
    var smartSpeaker = this.props.DeviceReducer.list.find(
      (d) =>
        d.deviceId == this.props.smartSpeakerDeviceId ||
        d.deviceUId == this.props.smartSpeakerDeviceUId
    );
    if (smartSpeaker) {
      //console.log("smartSpeaker in MediaPlayerList.render", smartSpeaker);
      if (
        smartSpeaker.currentPlayListId > 0 ||
        this.state.currentPlayListId > 0
      ) {
        var _currentPlayListId = this.state.currentPlayListId;

        if (
          this.props.DeviceReducer.playLists &&
          this.props.DeviceReducer.playLists.length > 0
        ) {
          var playList = this.props.DeviceReducer.playLists.filter(
            (p) => p.id == _currentPlayListId
          )[0];
          if (playList) {
            return this.renderPlayListInfo(playList);
          }
        }
      }
      return this.renderPlayLists();
    }

    return <Text></Text>;
  }
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 15,
    paddingTop: 15,
  },
  heading: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    color: ArTheme.COLORS.MUTED,
  },
  playListItem: {
    flexDirection: "row",
    // borderTopWidth: 1,
    // borderBottomWidth: 1,
    // borderColor: ArTheme.COLORS.BORDER,
    backgroundColor: ArTheme.COLORS.GRAY_LIGHT,
    borderRadius: 12,
    marginBottom: 8,
    paddingHorizontal: 10,
    height: 56,
    alignItems: "center",
  },
  playListTitle: {
    flex: 1,
    marginHorizontal: 5,
  },
});

const mapStateToProps = (state) => {
  return { AppReducer: state.AppReducer, DeviceReducer: state.DeviceReducer };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllPlaylists: (accessToken) =>
      dispatch(DeviceActions.GetAllPlaylists(accessToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaPlayerList);
